// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__23QVc","selected":"styles_selected__Ovv5G"};